import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  AfterViewChecked,
  NgZone,
} from "@angular/core";
import { ModalService } from "../services/modal.service";
import { UsersService } from "../services/users.service";
import { PermissionModel } from "@models/permission.model";
import { CONSTANTS } from "@config/constants";
import { SubjectService } from "@app/services/subject.service";
import { Observable } from "rxjs";
import { AuthService } from "@services/auth.service";
import { CashNowService } from "@app/services/cash-now.service";
import { environment } from "../../environments/environment";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"],
})
export class PagesComponent implements OnInit, AfterViewChecked {
  public navigation = [
    {
      idOption: "1",
      alt: "Transacciones",
      img: "icon-transactions-menu.svg",
      path: "/pages/transacciones",
    },
    {
      idOption: "8",
      alt: "Solicitar cupo",
      img: "icon-client-study.svg",
      path: "/pages/estudio-de-cliente",
    },
    {
      idOption: "3",
      alt: "Mis clientes",
      img: "icon-users.svg",
      path: "/pages/mis-clientes",
    },
    {
      idOption: "9",
      alt: "Operaciones",
      img: "icon-operations.svg",
      path: "/pages/operaciones",
    },
    // {
    //   alt: 'Reclamaciones',
    //   img: 'icon-claims.svg',
    //   path: '/pages/reclamaciones',
    // },
    {
      idOption: "14",
      alt: "Reintegros",
      img: "icon-claims.svg",
      path: "/pages/reintegros",
    },
    {
      idOption: "16",
      alt: "Acuerdos de pago",
      img: "icon-agreements.svg",
      path: "/pages/acuerdos-de-pago",
    },
    {
      idOption: "17",
      alt: "Reportes",
      img: "icon-reports.svg",
      path: "/pages/reportes",
    },
    {
      idOption: null,
      alt: "Administración",
      img: "icon-administration.svg",
      path: "/pages/administracion/mis-pagos",
      subItems: [
        {
          idOption: "26",
          alt: "Mis pagos",
          img: "icon-my-payments.svg",
          path: "/pages/administracion/mis-pagos",
        },
        {
          idOption: "29",
          alt: "Usuarios",
          img: "icon-users.svg",
          path: "/pages/administracion/usuarios",
        },
        {
          idOption: "32",
          alt: "Documentos",
          img: "icon-documents.svg",
          path: "/pages/administracion/principal",
        },
        {
          idOption: "35",
          alt: "Radicación",
          img: "icon-documents.svg",
          path: "/pages/administracion/radicacion", 
          activeRol: this.handlePermissionsToClaims()
        },
        {
          idOption: "37",
          alt: "Consultar estado",
          img: "icon-documents.svg",
          path: "/pages/administracion/consultar-estado", 
          activeRol: this.handlePermissionsToClaims()
        },
      ],
    },
  ];

  public collapseMenu: Observable<boolean> = this.subject.stateMenu$;
  public collapseHeader: Observable<boolean> = this.subject.stateHeader$;
  public showSubMenu: boolean = false;
  public permissions: Array<PermissionModel>;
  public quotaStudy: boolean;
  public constants = CONSTANTS;
  public innerWidth: number;
  public onLaptopBreakpoint: boolean = true;
  public onMobileBreakpoint: boolean = false;
  public showMenu: boolean = false;
  public showHeader: boolean = false;
  public count: number = 0;
  public valHidenSubMenu: string = "none";
  public modalOpened : boolean = false;
  public isSubMenuActive: boolean = false;
  public isAuthorizedToFactoring: boolean = false;
  public whatsApp: string;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.updatedResize();
  }

  constructor(
    private auth: AuthService,
    private modal: ModalService,
    private usersService: UsersService,
    public subject: SubjectService,
    private cdRef: ChangeDetectorRef,
    private cashNow: CashNowService,
    public zone: NgZone
  ) { 
    this.whatsApp = environment.whatsAppUrl;
  }

  ngOnInit() {
    this.collapseHeader.subscribe((show: boolean) => {
      this.zone.run(() => (this.showHeader = show));
    });
    this.updatedResize();
    this.handlePermissions();
    this.isAuthorizedToUseCashNow(); 
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  updatedResize() {
    this.innerWidth = window.innerWidth;
    this.onLaptopBreakpoint =
      this.innerWidth > 200 && this.innerWidth < 1600 ? true : false;
    this.onMobileBreakpoint =
      this.innerWidth > 0 && this.innerWidth < 768 ? true : false;
    this.subject.menuCollapse(this.onLaptopBreakpoint);
    this.subject.isMobile(this.onMobileBreakpoint);
  }

  handlePermissions() {
    this.permissions = this.usersService.permissions;
    this.quotaStudy = this.usersService.quotaStudy;
   
    this.navigation = this.navigation.map((page) => {
      const { idOption, subItems, ...rest } = page;
   
      // La opción con idOption "3" debe estar activa siempre
      if (idOption === "3") {
        return {
          idOption,
          status: CONSTANTS.PERMISSIONS.ACTIVE,
          subItems: subItems ? subItems.map(item => ({
            ...item,
            status: CONSTANTS.PERMISSIONS.ACTIVE
          })) : [],
          ...rest
        };
      }
   
      // Obtener el estado de permisos de la opción actual
      const permissionStatus = this.permissions.find(permission => permission.idOption === idOption);
      let status = permissionStatus ? permissionStatus.status : CONSTANTS.PERMISSIONS.ACTIVE;
   
      if (idOption === "8") {
        status = !this.quotaStudy
          ? CONSTANTS.PERMISSIONS.DISABLED
          : permissionStatus ? permissionStatus.status : CONSTANTS.PERMISSIONS.ACTIVE;
      }
   
      return {
        idOption,
        status,
        subItems: subItems ? subItems.map(item => {
          const subItemPermission = this.permissions.find(permission => permission.idOption === item.idOption);
          return {
            ...item,
            status: subItemPermission ? subItemPermission.status : CONSTANTS.PERMISSIONS.ACTIVE
          };
        }) : [],
        ...rest
      };
    });
  }

  handleDropdown(item?: string, subItems?: any) {
    this.showSubMenu = item === "Administración" ? true : false;
 
    if (this.showSubMenu && !subItems) {
      if (this.count === 1) {
        this.count = 0;
        this.valHidenSubMenu = "none";
        this.isSubMenuActive = false;
      } else {
        this.valHidenSubMenu = "block";
        this.isSubMenuActive = true;
        this.count++;
      }
    } else if (!this.showSubMenu) {
      this.count = 0;
      this.valHidenSubMenu = "none";
      this.isSubMenuActive = false;
    }

    if (
      (this.onMobileBreakpoint && !this.showSubMenu) ||
      (this.onMobileBreakpoint && subItems)
    ) {
      this.collapseSidebar();
    }
  }

  validateHidden(): string {
    return this.valHidenSubMenu;
  }

  enter(path: string) {
    this.collapseMenu.subscribe((show: boolean) => (this.showMenu = show));
    if (this.onLaptopBreakpoint && this.showMenu) {
      this.subject.sendText(path);
    }
  }

  leave() {
    if (this.onLaptopBreakpoint && this.showMenu) {
      this.subject.sendText("");
    }
  }

  showModalLogOut() {
    (window as any).gtag("event", "cerrar-sesion-sin-conrmar", {
      event_category: "cerrar-sesión",
      event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.userInfo.email}`,
    });
    this.modal.show("logOut");
  }

  collapseSidebar() {
    this.showMenu = !this.showMenu;
    this.subject.menuCollapse(this.showMenu);
  }

  openWhatsapp() {
    (window as any).gtag('event', 'ayuda-sac', {
      event_category: 'con-login',
      event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.username}`,
    });
    window.open(this.whatsApp, '_newtab');
  }
  
  openExperience(event: any) {
    this.modalOpened = !this.modalOpened;
  }

  isAuthorizedToUseCashNow() {
    const requestUserInfo = {
      usuario: this.auth.identity.username.toUpperCase(),
      tipoDocumento: this.auth.identity.userInfo.documentType,
      numeroDocumento: this.auth.identity.userInfo.document
    }

    this.cashNow.validateUserStatusCashNow(requestUserInfo, false).subscribe(
      (res) => {
        console.log("Caja Ya", res);
        this.isAuthorizedToFactoring = res;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  handlePermissionsToClaims() : boolean{
    // Metodo para mostrar en el menu la seccion de reclamaciones
    const rol = this.auth.getIdentity().userInfo.useRoler;
    if( rol == "2" ||  rol == "1") return true;
    return false;
  }

  validatePermissionsToClaims(key) {
    if(key === true) return true;
    if(key === false) return false;
    if(!key) return true;
  }
}
